<div class="qr-wrap">
  <i class="fa fa-cog qr-inner"></i>
  <qrcode [qrdata]="qrData" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
</div>
